<template>
  <v-dialog persistent width="80%" v-model="convocatoriaDialog">
    <template v-slot:activator="{ on, attrs }">
      <TextButton rounded color="secondary" v-on="on" v-bind="attrs">Registrar convocatoria</TextButton>
    </template>
    <v-card color="primary" class="rounded-sm">
      <v-card-title>
        <div class="text-h6 font-weight-bold">Nueva convocatoria</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form v-model="form" ref="form">
            <v-row>
              <v-col cols="4">
                <BaseSelect
                  v-model="convocatoria.fk_idTipoConvocatoria"
                  :items="tipoConvocatoria"
                  item-color="secondary"
                  item-value="id"
                  item-text="title"
                  :rules="required"
                >
                  <template v-slot:label>Tipo de convocatoria <span class="red--text">*</span> </template>
                </BaseSelect>
              </v-col>
              <v-col cols="4">
                <BaseSelect
                  v-model="convocatoria.tipoSeleccionado"
                  :items="tipoSeleccionadoItems"
                  :label="tipoSeleccionadoLabel"
                  :rules="required"
                  :disabled="!tipoConvocatoriaSeleccionada"
                ></BaseSelect>
              </v-col>
              <v-col cols="4" v-if="tipoConvocatoriaSeleccionada === 'Externa'">
                <BaseSelect
                  v-model="convocatoria.gradoPromocionar"
                  :items="gradosPromocionar"
                  label="Grado a promocionar"
                  :rules="required"
                ></BaseSelect>
              </v-col>
              <v-col cols="5">
                <BaseInput v-model="convocatoria.convocatoria" :rules="required">
                  <template v-slot:label>Nombre de convocatoria <span class="red--text">*</span> </template>
                </BaseInput>
              </v-col>
              <v-col cols="3">
                <BaseInput v-model="convocatoria.dirigidaA" :rules="required">
                  <template v-slot:label>Dirigida a <span class="red--text">*</span> </template>
                </BaseInput>
              </v-col>
              <v-col cols="4">
                <BaseInput
                  label="Lugar de recepción de documentación"
                  v-model="convocatoria.lugarRecepcionDocumentos"
                ></BaseInput>
              </v-col>
              <v-col cols="4">
                <v-textarea
                  label="Requisitos"
                  v-model="convocatoria.requisitos"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  no-resize
                  rows="4"
                  :rules="required"
                >
                  <template v-slot:label>Requisitos <span class="red--text">*</span> </template>
                </v-textarea>
              </v-col>
              <v-col cols="4">
                <v-textarea
                  v-model="convocatoria.beneficios"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  no-resize
                  rows="4"
                  :rules="required"
                >
                  <template v-slot:label>Beneficios <span class="red--text">*</span> </template>
                </v-textarea>
              </v-col>
              <v-col cols="4">
                <v-textarea
                  v-model="convocatoria.plazasVacantes"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  no-resize
                  rows="4"
                  :rules="required"
                >
                  <template v-slot:label>Plazas vacantes <span class="red--text">*</span> </template>
                </v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  label="Documentación necesaria"
                  v-model="convocatoria.documentacion"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  no-resize
                  rows="4"
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  label="Procedimiento de selección"
                  v-model="convocatoria.procedimientoSeleccion"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  no-resize
                  rows="4"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col class="pa-0">
                    <div class="text-caption">
                      Fecha de publicación de convocatoria <span class="red--text">*</span>
                    </div>
                    <date-picker
                      v-model="convocatoria.fechaHoraPublicacionConvocatoria"
                      type="datetime"
                      valueType="YYYY-MM-DD HH:mm:ss"
                    ></date-picker>
                  </v-col>
                  <v-col class="pa-0">
                    <div class="text-caption">Fecha de recepción documentación <span class="red--text">*</span></div>
                    <date-picker
                      v-model="convocatoria.fechaHoraRecepcionDocumentos"
                      type="datetime"
                      valueType="YYYY-MM-DD HH:mm:ss"
                    ></date-picker>
                  </v-col>
                  <v-col class="pa-0">
                    <div class="text-caption">Fecha de inicio de registro <span class="red--text">*</span></div>
                    <date-picker
                      v-model="convocatoria.fechaHoraInicioRegistro"
                      type="datetime"
                      valueType="YYYY-MM-DD HH:mm:ss"
                    ></date-picker>
                  </v-col>
                  <v-col class="pa-0">
                    <div class="text-caption">Fecha de cierre de registro <span class="red--text">*</span></div>
                    <date-picker
                      v-model="convocatoria.fechaHoraCierreRegistro"
                      type="datetime"
                      valueType="YYYY-MM-DD HH:mm:ss"
                    ></date-picker>
                  </v-col>
                  <v-col class="pa-0">
                    <div class="text-caption">Fecha de resultados <span class="red--text">*</span></div>
                    <date-picker
                      v-model="convocatoria.fechaHoraResultados"
                      type="datetime"
                      valueType="YYYY-MM-DD HH:mm:ss"
                    ></date-picker>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <TextButton
          color="secondary"
          :loading="loading"
          :disabled="!validForm || loading"
          @click="triggerSaveConvocatoria()"
          >Registrar</TextButton
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import BaseSelect from '@src/components/base/BaseSelect.vue'
import TextButton from '@src/components/base/TextButton.vue'
import BaseInput from '@src/components/base/BaseInput.vue'

export default {
  components: { DatePicker, BaseSelect, TextButton, BaseInput },

  data() {
    return {
      convocatoriaDialog: false,
      form: false,
      loading: false,
      tipoConvocatoriaSeleccionada: null,
      gradosPromocionar: [
        'Comisario General',
        'Comisario Jefe',
        'Comisario',
        'Inspector General',
        'Inspector Jefe',
        'Inspector',
        'Subinspector',
        'Oficial',
        'Suboficial',
        'Policía Primero',
        'Policía Segundo',
        'Policía Tercero',
        'Policía',
      ],
      convocatoria: {
        fk_idTipoConvocatoria: null,
        gradoPromocionar: null,
        tipoSeleccionado: null,
        convocatoria: '',
        dirigidaA: '',
        beneficios: '',
        plazasVacantes: '',
        requisitos: '',
        documentacion: '',
        lugarRecepcionDocumentos: '',
        procedimientoSeleccion: '',
        fechaHoraRecepcionDocumentos: null,
        fechaHoraPublicacionConvocatoria: null,
        fechaHoraInicioRegistro: null,
        fechaHoraCierreRegistro: null,
        fechaHoraResultados: null,
        fk_idTipoConvocatoria: null,
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('tipoConvocatoria', {
      tipoConvocatoria: 'getTipoConvocatoria',
    }),
    tipoSeleccionadoLabel() {
      if (this.tipoConvocatoriaSeleccionada === 'Interna') return 'Interna'
      if (this.tipoConvocatoriaSeleccionada === 'Externa') return 'Externa'
      return 'Seleccione tipo'
    },
    tipoSeleccionadoItems() {
      if (this.tipoConvocatoriaSeleccionada === 'Interna') {
        return ['Proximidad', 'Penitenciario', 'Administrativo']
      }
      if (this.tipoConvocatoriaSeleccionada === 'Externa') {
        return ['Proximidad', 'Penitenciario']
      }
      return []
    },
    validForm() {
      if (
        this.form &&
        this.convocatoria.fechaHoraRecepcionDocumentos &&
        this.convocatoria.fechaHoraPublicacionConvocatoria &&
        this.convocatoria.fechaHoraInicioRegistro &&
        this.convocatoria.fechaHoraCierreRegistro &&
        this.convocatoria.fechaHoraResultados
      ) {
        return true
      } else return false
    },
  },

  methods: {
    ...mapActions('convocatoria', ['saveConvocatoria', 'fetchConvocatoria']),

    closeDialog() {
      this.$refs.form.resetValidation()
      this.convocatoriaDialog = false
      this.loading = false

      this.convocatoria = {
        fk_idTipoConvocatoria: null,
        tipoSeleccionado: null,
        convocatoria: '',
        dirigidaA: '',
        beneficios: '',
        plazasVacantes: '',
        requisitos: '',
        documentacion: '',
        lugarRecepcionDocumentos: '',
        procedimientoSeleccion: '',
        fechaHoraRecepcionDocumentos: null,
        fechaHoraPublicacionConvocatoria: null,
        fechaHoraInicioRegistro: null,
        fechaHoraCierreRegistro: null,
        fechaHoraResultados: null,
      }
    },

    async triggerSaveConvocatoria() {
      this.loading = true
      await this.saveConvocatoria(this.convocatoria)
      await this.fetchConvocatoria(1)

      this.closeDialog()
    },
  },
  watch: {
    'convocatoria.fk_idTipoConvocatoria'(newVal) {
      const tipo = this.tipoConvocatoria.find((tc) => tc.id === newVal)
      this.tipoConvocatoriaSeleccionada = tipo ? tipo.title : null
      this.convocatoria.tipoSeleccionado = null // Limpia el valor al cambiar tipo
    },
  },
}
</script>
